<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-md-6 mb-3 mb-md-0">
          <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb/>
          </nav>
        </div>

      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col">
          <div class="card">

            <div class="card-header mb-4">
                  <base-button outline type="celcompink" class="btn-icon-only rounded-circle mb-3" @click.prevent="back()">
                    <span class="btn-inner--icon"><i class="fas fa-angle-left"></i></span>
                  </base-button>
                <span>  Edicion :  {{this.name}} </span>
            </div>

            <iframe frameBorder="0" height="700" width="100%" :src="'https://landing.celcomsms.com/editor.php?option='+this.option+'&customerUserId='+user.customerUserId+'&customerId='+customer.customerId+'&ladingId='+this.ladingId+'&file='+this.fileName+'&name='+this.name"></iframe>


          </div>
    </div>
    </div>
    </div>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Select,
  Option
} from "element-ui";
import { BasePagination, Modal, Dialog } from "@/components";
import DropzoneFileUpload from "@/components/Inputs/DropzoneFileUpload";
import FileInput from "@/components/Inputs/FileInput";
import moment from "moment";
import XLSX from "xlsx";
import clientPaginationMixin from "@/views/Tables/PaginatedTables/clientPaginationMixin";

 import swal from 'sweetalert2';
import AES256 from "aes-everywhere";
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import Config from "@/config/config.js";
import { getUser, setUser, encryptAES, horaAhora, search_data, onPermissionsUser,getUserSub } from "@/util/util.js";

Vue.use(VueAxios, axios);
Vue.use(Dialog);

export default {
  mixins: [clientPaginationMixin],
  components: {
    DropzoneFileUpload,
    BasePagination,
    FileInput,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    Modal,
    Dialog
  },
  data() {
    return {
      inputs: {
        file: []
      },
      name:(typeof this.$route.query.name !== 'undefined') ? this.$route.query.name : "Nuevo",
      fileName:"",
      ladingId:(typeof this.$route.query.id !== 'undefined') ? this.$route.query.id : 0,
      option:(typeof this.$route.query.id !== 'undefined') ? "edit" : "add",
      user:getUser(),
      customer: getUser().customer,
      keySearch:"",
      currentPage: 1,
      tableData: [],
      listaContactos: [],
      selectedRows: [],
      tabContact: false,
      listaNombre: "",
      contactGroup: {},
      contactSingle: {},
      draftSingle: {
        name:"",
        message: "",
        master:false,
        shortUrlValue:"",
        shortUrl:false,
        cloudinaryId:"",
        contactGroup:{
          contactGroupId:""
        }
      },
      modals: {
        formSingle: false,
        formGroup: false,
        advertenciaSingle: false,
        advertenciaGroup: false,
        agregarBorrador: false,
        agregarMasivo: false
      },
      fileSingle: [],
      selectOptionsListContact: [],
      validForm: {
        estado: false,
        field: "",
        campaingName: "",
        CodePhoneContact: getUser().customer.country.phoneCode,
        PhoneContact: "",
        listContact: "",
        dateProgramgContact: "",
        menssageContact: "",
        selectDraft: "",
        StepPreview: false,
        dateSend: "",
        sendingsms: "",
        contacts: [],
        headersContactList: [],
        fileUrl: []
      },
      permisos: {
        create: onPermissionsUser('drafts.xhtml', 'create'),
        modify: onPermissionsUser('drafts.xhtml', 'modify'),
        destroy: onPermissionsUser('drafts.xhtml', 'destroy'),
      }
    };
  },
  methods: {


    back(){

      window.location.href="/envios/sms-link";

    },

     obtenerLista() {

      let self = this;
      let user = (getUserSub()!=null) ? getUserSub() :getUser();

      //self.$loading.show();

      let js = {
        time_expired: horaAhora(),
        "customer_user":encodeURIComponent(JSON.stringify(user)),
        "landing_id":encodeURIComponent(this.ladingId),
      };

      var body = new URLSearchParams();
      body.append("TOKEN", encryptAES(js));

      Vue.axios
        .post(Config.url_service + Config.landing_show, body, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        })
        .then(function(response) {
          console.log(response);

          if (response.data.response === "200") {
            console.log(response.data.data);

            self.fileName = encodeURIComponent(response.data.data.nameFile);
            self.name = response.data.data.name;


          } else {
            console.log("No se encontró lista");
            swal({
              title: "No se encontró lista",
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-danger',
              type: 'warning',
            })

          }
         // self.$loading.hide();

        })
        .catch(function(error) {
          console.log("No se encontró lista", error);
          swal({
              title: "No se encontró lista",
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-danger',
              type: 'warning',
          })

         // self.$loading.hide();

        });
    },

  },
  mounted() {


      if(this.option=="edit"){

          this.obtenerLista();

      }

    if(!onPermissionsUser('drafts.xhtml', 'view')) {
        swal({
          title: 'No tienes los permisos para acceder a esta página.',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-danger',
          type: 'error',
          }).then(function() {
            window.location.href="/dashboard";
        })

      }
  },
  create() {
    this.$loading.show();
  },
  computed: {}
};
</script>

<style>
.busy-mask {
  z-index: 1051;
}
</style>
